import Link from 'next/link';

export const LinkCustom = (props) => {
    if (props.spread || props.external) {
        return <> { props.children } </>;
    } else {
        return <Link href={props.href} as={props.as} shallow={true}>{ props.children }</Link>
    }
};